import React from 'react';
import '../css/style/policy.css';

const POLICIES = {
    terms: {
        title: '이용약관',
        content: `최종 수정일: 2026년 5월 15일

1. 약관의 동의

Keep AI(또는 킵에이아이, 키파이 이하 "서비스")에 접속하거나 이용함으로써 귀하는 본 이용약관(이하 "약관")에 동의하는 것으로 간주됩니다. 동의하지 않으시면 서비스를 이용하지 마십시오.

2. 서비스 설명

Keep AI는 생성형 AI 서비스(Chat GPT 등)의 할인 구독 상품 및 관련 서비스를 제공하는 플랫폼입니다.
본 서비스는 사용자가 보다 합리적인 가격으로 AI 서비스를 이용할 수 있도록 다양한 할인 구독 상품, 프로모션, 체험 서비스 및 부가 기능을 제공합니다.

3. 계정 등록

귀하는 계정의 보안을 유지할 책임이 있습니다.
정확하고 완전한 정보를 제공해야 합니다.

4. 귀하의 Chat GPT 계정

Keep AI를 이용하기 위해 귀하는 당사에 Chat GPT 관련 서비스 이용 권한을 제공할 수 있으며, 귀하는 다음 사항을 인정합니다:

• 귀하가 해당 Chat GPT 계정의 정당한 소유자 또는 이용 권한자임
• Keep AI는 서비스 제공을 위해 필요한 범위 내에서 계정 상태 및 이용 가능 여부를 확인할 수 있음
• Keep AI는 이용자의 개인 검색 기록, 대화 내용 또는 민감한 개인정보를 판매하지 않음
• 언제든지 계정 연결을 해제하여 서비스 접근을 중단할 수 있음
• 계정 이용 과정에서 발생하는 요금 및 사용 책임은 귀하에게 있음

5. 구독 및 결제

Keep AI는 무료 체험과 유료 구독 상품을 제공합니다.
유료 상품은 제휴 PG사를 통해 신용카드 또는 기타 결제수단으로 정기 결제될 수 있습니다.
업그레이드는 즉시 적용되며, 일할 계산된 요금이 청구될 수 있습니다.
언제든지 구독을 취소할 수 있으며, 취소 후에도 결제 기간 종료 시까지 서비스를 이용할 수 있습니다.

6. 결제 취소 및 환불 규정

전자상거래 등에서의 소비자보호에 관한 법률 제17조에 따라 서비스 제공 개시일로부터 7일 이내에 청약을 철회할 수 있습니다. 다만, 실제 서비스 이용이 개시된 경우 관련 법령에 따라 청약철회가 제한될 수 있습니다.

회사는 결제 전 환불 제한 사항을 고지하며, 무료 체험 기능을 제공합니다.

6-1. 전액 환불
결제 후 7일 이내이면서 실제 서비스 미이용 시: 전액 환불 가능
7일 경과 또는 서비스 이용 시작 시: 환불 불가

6-2. 환불 없는 구독 해지
월간 구독: 언제든지 해지 가능
연간 구독: 추후 개발 예정
해지 후 현재 결제 기간 종료 시까지 서비스 이용 가능
부분 환불 및 비례 환불은 제공되지 않음

6-3. 회사 귀책 사유
회사의 귀책 사유로 서비스 장애 또는 결제 오류가 발생한 경우, 남은 이용 기간에 해당하는 금액을 기준으로 환불이 진행됩니다.
환불 요청은 채널톡 고객센터 또는 1566-2144을 통해 접수할 수 있으며, 환불은 영업일 기준 5~7일 이내 처리됩니다.

7. 이용 규칙

귀하는 다음 행위를 하지 않을 것에 동의합니다:

• 불법적인 목적으로 서비스를 이용하는 행위
• 서비스의 시스템 또는 소스 코드를 역설계, 디컴파일 또는 추출하려는 행위
• 권한 없는 제3자에게 계정 정보를 공유하는 행위
• 스팸, 허위 정보 또는 불법 콘텐츠 생성 목적으로 서비스를 이용하는 행위
• 서비스 운영을 방해하거나 시스템에 과부하를 유발하는 행위
• 회사의 승인 없이 자동화 프로그램 또는 매크로를 사용하는 행위

8. AI 생성 콘텐츠

Keep AI는 Chat GPT의 인공지능 기술을 활용하여 콘텐츠 및 응답을 제공합니다. 귀하는 다음 사항을 인정합니다:

• AI 생성 결과는 참고용으로 제공될 수 있음
• 생성된 콘텐츠에 대한 최종 검토 및 책임은 사용자에게 있음
• Keep AI는 특정 결과, 수익, 정확성 또는 생산성 향상을 보장하지 않음

9. 서비스 안정성

Keep AI는 안정적인 서비스 제공을 위해 노력합니다. 다만, 네트워크 환경 또는 제3자 서비스 장애로 인해 일시적인 중단이 발생할 수 있습니다.

10. 서비스 가용성

당사는 높은 가용성을 위해 노력하지만, 중단 없는 서비스를 보장하지는 않습니다.
본 서비스는 OpenAI, Google, 제휴PG사 등 제3자 서비스에 의존할 수 있으며, 해당 서비스의 장애로 인해 일부 기능이 제한될 수 있습니다.

11. 지식재산권

Keep AI 및 관련 서비스의 디자인, 로고, 기능 및 콘텐츠는 회사의 자산이며 관련 법률의 보호를 받습니다.
사용자가 입력하거나 생성한 콘텐츠의 권리는 해당 사용자에게 있습니다.

12. 책임의 제한

법률이 허용하는 최대 범위 내에서, Keep AI는 서비스 이용 과정에서 발생하는 간접적, 우발적, 특별한 손해 또는 데이터 손실 등에 대해 책임을 지지 않습니다.
서비스와 관련한 회사의 총 책임 한도는 최근 12개월 동안 사용자가 회사에 지급한 금액을 초과하지 않습니다.

13. 계약 해지

회원이 본 약관을 위반한 경우 회사는 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.
다만, 불법행위 또는 보안 위협 등 긴급한 사유가 있는 경우 사전 통지 없이 즉시 제한될 수 있습니다.

14. 약관의 변경

회사는 관련 법령 범위 내에서 본 약관을 수정할 수 있습니다.
중대한 변경 사항은 최소 30일 전에 서비스 내 공지 또는 이메일 등을 통해 안내합니다.

15. 준거법

본 약관은 대한민국 법률에 따라 규율되고 해석됩니다.
서비스 이용과 관련한 분쟁은 회사 본점 소재지 관할 법원을 전속 관할로 합니다.

16. 문의

본 약관에 대한 문의 사항은 아래 연락처로 연락해 주십시오.
고객센터: 1566-2144

개인정보 처리에 관한 사항은 별도의 개인정보처리방침에 따릅니다.`,
    },

    privacy: {
        title: '개인정보 처리방침',
        content: `최종 수정일: 2026년 5월 15일

Keep AI(또는 킵에이아이, 키파이 이하 "서비스")는 이용자의 개인정보를 중요하게 생각하며, 「개인정보 보호법」 등 관련 법령을 준수합니다.
회사는 이용자의 개인정보를 안전하게 보호하기 위해 다음과 같은 개인정보 처리방침을 수립·운영합니다.

1. 수집하는 개인정보 항목

회사는 서비스 제공을 위해 아래와 같은 개인정보를 수집할 수 있습니다.

1-1. 회원가입 및 로그인 시
• 이메일 주소
• 이름
• 연락처
• OAuth 인증 정보(Google 등)

1-2. 서비스 이용 시
• 접속 로그
• IP 주소
• 브라우저 정보
• 기기 정보
• 이용 기록
• 결제 및 구독 이용 내역

1-3. 결제 시
• 결제 수단 정보
• 결제 승인 내역
• 주문 및 환불 기록

※ 카드번호 및 비밀번호 등 민감한 결제정보는 제휴PG사 등 전자결제대행사가 직접 처리하며, 회사는 절대 대여 또는 판매하지 않습니다.

2. 개인정보의 수집 및 이용 목적

회사는 다음 목적을 위해 개인정보를 이용합니다.

• 회원 식별 및 계정 관리
• 서비스 제공 및 운영
• 구독 및 결제 처리
• 고객 문의 대응
• 부정 이용 방지 및 보안 관리
• 서비스 품질 개선 및 통계 분석
• 이벤트 및 공지사항 안내
• 법령 및 약관 위반 대응

3. 개인정보의 보관 및 이용 기간

회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
다만, 관련 법령에 따라 일정 기간 보관이 필요한 경우 아래와 같이 보관할 수 있습니다.

• 계약 또는 청약철회 기록: 5년 (전자상거래법)
• 결제 및 공급 기록: 5년 (전자상거래법)
• 소비자 불만 및 분쟁처리 기록: 3년 (전자상거래법)
• 접속 로그: 3개월 (통신비밀보호법)

4. 개인정보의 제3자 제공

회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
다만, 아래의 경우에는 예외로 합니다.

• 이용자가 사전에 동의한 경우
• 법령에 따라 제출 의무가 있는 경우
• 수사기관 등 관계기관의 적법한 요청이 있는 경우

5. 개인정보 처리 위탁

회사는 원활한 서비스 제공을 위해 일부 업무를 외부 업체에 위탁할 수 있습니다.

• Google — OAuth 로그인 인증
• 제휴PG사 — 결제 처리
• OpenAI — API 및 AI 서비스 제공
• AWS 또는 기타 클라우드 사업자 — 서버 운영 및 데이터 저장

회사는 위탁계약 체결 시 개인정보 보호 관련 법령을 준수합니다.

6. 이용자의 권리 및 행사 방법

이용자는 언제든지 다음 권리를 행사할 수 있습니다.

• 개인정보 열람 요청
• 개인정보 수정 요청
• 개인정보 삭제 요청
• 처리 정지 요청
• 회원 탈퇴 요청

요청은 고객센터 또는 이메일을 통해 접수할 수 있으며, 회사는 관련 법령에 따라 처리합니다.

7. 개인정보의 파기 절차 및 방법

회사는 개인정보 보관 기간이 종료되거나 처리 목적이 달성된 경우 지체 없이 해당 정보를 파기합니다.

• 전자적 파일: 복구가 불가능한 방법으로 영구 삭제
• 종이 문서: 분쇄 또는 소각 처리

8. 쿠키(Cookie)의 사용

회사는 이용자 편의 및 서비스 개선을 위해 쿠키를 사용할 수 있습니다.
쿠키를 통해 아래 정보를 저장할 수 있습니다.

• 로그인 상태 유지
• 이용자 환경 설정
• 방문 기록 분석
• 서비스 이용 통계

이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.

9. 개인정보 보호를 위한 조치

회사는 개인정보 보호를 위해 다음과 같은 조치를 시행합니다.

• SSL 암호화 통신 적용
• 접근 권한 제한
• 관리자 최소 권한 운영
• 개인정보 접근 기록 관리
• 보안 시스템 운영
• 비정상 접근 탐지

10. 아동의 개인정보 보호

Keep AI는 만 13세 미만 아동의 회원가입 및 이용을 제한합니다.
회사는 법정대리인의 동의 없는 아동 개인정보를 의도적으로 수집하지 않습니다.

11. 개인정보 자동 수집 장치

회사는 서비스 운영 과정에서 자동 생성 정보를 수집할 수 있습니다.

• IP 주소
• 접속 시간
• 브라우저 종류
• 운영체제 정보
• 클릭 및 이용 기록

해당 정보는 서비스 안정성 및 보안 목적에 사용됩니다.

12. 개인정보 보호책임자

회사는 개인정보 관련 문의 및 불만 처리를 위해 아래 담당자를 지정합니다.

• 개인정보 보호책임자: Keep AI 운영팀
• 연락처: 1566-2144

13. 개인정보 처리방침 변경

회사는 관련 법령 또는 서비스 변경 사항에 따라 개인정보 처리방침을 수정할 수 있습니다.
중대한 변경 사항은 서비스 내 공지사항 또는 이메일 등을 통해 사전 안내합니다.

14. 문의

개인정보 처리방침에 대한 문의 사항은 아래로 연락해 주십시오.
고객센터: 1566-2144`,
    },

    about: {
        title: '서비스 소개',
        images: [
            require('../resource/use1.png'),
            require('../resource/use2.png'),
            require('../resource/use3.png'),
            require('../resource/use4.png'),
            require('../resource/use5.png'),
            require('../resource/use6.png'),
        ],
    },
};

const PolicyModal = ({type, onClose}) => {
    const policy = POLICIES[type];
    if (!policy) return null;

    if (type === 'about') {
        return (
            <div className="policy-backdrop" onClick={onClose}>
                <div className="policy-modal policy-modal--about" onClick={e => e.stopPropagation()}>
                    <div className="policy-header">
                        <h2 className="policy-title">{policy.title}</h2>
                        <button className="policy-close" onClick={onClose}>✕</button>
                    </div>
                    <div className="about-image-row">
                        {policy.images.map((src, i) => (
                            <div key={i} className="about-image-item">
                                {src
                                    ? <img src={src} alt={`서비스 소개 ${i + 1}`} />
                                    : <div className="about-image-placeholder">{i + 1}</div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    const lines = policy.content.split('\n');

    return (
        <div className="policy-backdrop" onClick={onClose}>
            <div className="policy-modal" onClick={e => e.stopPropagation()}>
                <div className="policy-header">
                    <h2 className="policy-title">{policy.title}</h2>
                    <button className="policy-close" onClick={onClose}>✕</button>
                </div>
                <div className="policy-body">
                    {lines.map((line, i) => {
                        if (!line.trim()) return <div key={i} className="policy-spacer"/>;
                        if (/^\d+[\.\-]/.test(line.trim())) return <h3 key={i} className="policy-section">{line}</h3>;
                        if (line.trim().startsWith('•')) return <p key={i} className="policy-bullet">{line}</p>;
                        if (line.startsWith('※')) return <p key={i} className="policy-note">{line}</p>;
                        if (/^최종 수정일/.test(line.trim())) return <p key={i} className="policy-date">{line}</p>;
                        return <p key={i} className="policy-text">{line}</p>;
                    })}
                </div>
            </div>
        </div>
    );
};

export default PolicyModal;
